import React, {useEffect, useState, useMemo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getCustomer, patchUpdateCustomer } from 'redux/actions/UserCustomer';
import Loader from 'components/loader/Loader';
import CommonTable from 'components/commonTable/CommonTable';
import { dateFormate, handlePermissions } from 'utils/utils';
import { debounce } from 'lodash';
import CustomerBreadCrumb from './CustomerBreadCrumb';
import { filterdataCustomer } from './CustomerTableData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';

function CustomerTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

     const params = {};
     searchParams.forEach((value, key) => {
      params[key] = value;
    });

  const [page, setPage] = useState(params?.page ?  parseInt(params?.page) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(params?.pageSize ? parseInt(params?.pageSize) : 10);
  const [status, setStatus] = useState(params?.status ? params?.status : []);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const tableData = useSelector((state) => state?.userCustomer?.userCustomer?.data);
  const loader = useSelector((state) => state?.userCustomer?.loading);
  const [search, setSearch] = useState(params?.search ? params?.search : "");

   const modifiedTableData = useMemo(() => {
    if (!tableData) return null;
    
    // Get existing header from API
    const existingHeader = tableData?.header || [];
    
    // Find the position of "Status" column
    const statusIndex = existingHeader.findIndex(h => h.key === 'status');
    
    // Create new header array with wallet points inserted before Status
    const newHeader = [...existingHeader];
    
    // Insert wallet points column before Status (or at end if Status not found)
    const insertIndex = statusIndex !== -1 ? statusIndex : newHeader.length - 1;
    newHeader.splice(insertIndex, 0, {
      label: "Wallet Points",
      key: "walletPoints"
    });
    
    return {
      ...tableData,
      header: newHeader
    };
  }, [tableData]);

  let filterData = {
    id:'',
    page: params?.search ? 0 : page,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status:status,
    pageSize:rowsPerPage,
    search:search
  }

  useEffect(() => {
    dispatch(getCustomer(filterData));
  }, []);

  const onClickCustomer = (val) => {
    let url = window.location.pathname.split("/")[1]
    if (url === 'customer'){
      navigate(`/customer/detail`, {state: {id: val?.authId, name: val?.name, demandProfileId:val?.id}})
    }
  }
  
  const handleChangePage = (event,newPage) =>{
    setPage(newPage);
    setSearchParams({ ...params, page: newPage });
    dispatch(getCustomer({...filterData, page:newPage}))
  }

  const handleChangeRowsPerPage = (event) =>{
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    setSearchParams({
      ...params,
      page: 0,
      pageSize: parseInt(event.target.value),
    });
    dispatch(getCustomer({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  }

  const onFilterChange = (val) => {
    setPage(0);
    setStatus(val)
    filterData = {...filterData, status:val.toString(), page: 0}
    setSearchParams({
      ...params,
      status: val.toString(),
      page: 0,
    });
    dispatch(getCustomer(filterData));
  }

  const onRestFilter = () => {
    setStatus("");
    setSearchParams({ ...params, status: ''});
    filterData = {...filterData, status:""}
    dispatch(getCustomer(filterData));
  }

  const onSelectDateRange = (newValue) => {
    setDateFrom(dateFormate(newValue[0]).format("MM/DD/YYYY"))
    setDateTo(dateFormate(newValue[1]).format("MM/DD/YYYY"))
    filterData = {...filterData, 
      dateFrom:dateFormate(newValue[0]).format("MM/DD/YYYY"),
      dateTo:dateFormate(newValue[1]).format("MM/DD/YYYY")
    }
    dispatch(getCustomer(filterData));
  }

  const onSearch = debounce((e) =>{
    setSearch(e);
    setPage(0);
    filterData = {...filterData, search:e, page: 0}
    setSearchParams({ ...params, search: e, page: 0, pageSize: '' });
    dispatch(getCustomer(filterData))
  },1000)

  const onClickMoreIcon = (data, iconType) => {
    if (iconType === 'Activate') {
      const profileData = {
        customerId: data.id,
        data: {
          status: 'Active',
          page:page,
          rowsPerPage:rowsPerPage
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    } else if (iconType === 'Block') {
      const profileData = {
        customerId: data.id,
        data: {
          status: 'Blocked',
          page:page,
          rowsPerPage:rowsPerPage
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    } else if (iconType === 'Unblock') {
      const profileData = {
        customerId: data.id,
        data: {
          status: 'Active',
          page:page,
          rowsPerPage:rowsPerPage
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    }
  };
  

   //roles and permissions
   const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const customerRoleEnum = roleAndPermissionEnum.customer;
  const accessForall = handlePermissions(
    roleAndPermissions,
    customerRoleEnum.moduleKey,
    {
      defaultAllAccess: customerRoleEnum.all,
    }
  );

  const accessForBlock = handlePermissions(
    roleAndPermissions,
    customerRoleEnum.moduleKey,
    {
      defaultAllAccess: customerRoleEnum.block,
    }
  );

  const hasViewMoreIcon = (accessForall|| accessForBlock)

  return (
    <>
        <CustomerBreadCrumb 
          defaultStatus={status}
          filterdata={filterdataCustomer} 
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          onSelectDateRange={onSelectDateRange}
          onSearch = {onSearch}
          searchValue={search}
        />
        {loader? 
        <Loader/> 
        :
        <CommonTable 
          data={modifiedTableData} 
          onClickTableVendor={onClickCustomer}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          tabName={'customer'}
          onClickMoreIcon={onClickMoreIcon}
          isClickable = {true}
          viewMoreIcon={!hasViewMoreIcon}
        />
        }
    </>
  )
}

export default CustomerTable